import React, { useState } from "react";
import Application from "../../Components/Application";
import ProductCard from "../../Components/Cards/Product";
import RecentProductCard from "../../Components/Cards/RecentProduct";
import Container from "../../Components/Container";
import SearchBox from "../../Components/SearchBox";
import Loading from "../../Components/Loading";
import { useLanding } from "./Hooks";
import { Link } from "react-router-dom";
import PartenersCard from "../../Components/PartnersCard";
import CustomSlider from "../../Components/Sliders/CustomSlider";
import { cutText } from "../../Utils/functions";
import sliderImg1 from "../../Assets/images/Ad/AdBaner (1)-min.jpg";
import sliderImg2 from "../../Assets/images/Ad/AdBaner (2)-min.jpg";
import sliderImg3 from "../../Assets/images/Ad/AdBaner (3)-min.jpg";
import AdSlider from "./components/AdSliders";

const Home = () => {
  const { loading, data, mainData } = useLanding();

  const [adSrc, setAdSrc] = useState([sliderImg1, sliderImg2]);
  const [adSrc2, setAdSrc2] = useState([sliderImg3]);

  return (
    <div className="container">
      <div className="row">
        <div className="col">
          <h1 className="ft-24 mb-15 text-center">نیازمندی های رایگان صنعت</h1>
          <p className="ft-15 mb-28 text-center">
            خرید و فروش لوازم صنعتی، خرید و فروش مطمئن و تایید شده، خرید و فروش
            دستگاه های صنعتی، آگهی استخدام در صنعت
          </p>
        </div>
      </div>

      <div className="row px-3 justify-content-center">
        <SearchBox className="mb-30" mainData={mainData} />
      </div>

      <div className="category-box">
        {loading ? (
          <Loading count={13} height={"100px"} />
        ) : (
          data?.categories?.map(category => {
            return (
              <div className="category">
                <Link to={`/ads/all?category_parent_id=${category.id}`} href="">
                  <div className="element">
                    <div className="mb-2">
                      <img
                        src={
                          category?.image?.url ||
                          require("../../Assets/images/3.png")
                        }
                        alt={category?.image?.alt}
                      />
                    </div>
                    <div>
                      <h3>{cutText(category?.title, 25)}</h3>
                    </div>
                  </div>
                </Link>
              </div>
            );
          })
        )}
      </div>

      <Container
        title={"آگهی های تایید شده"}
        subtitle="این آگهی ها توسط صنعتبان تایید شده است"
        link={"مشاهده همه"}
        className="mt-5 mb-4">

        <div className="row ">
          {loading ? (
            <Loading count={4} />
          ) : (
            data?.verified?.map(ver => {
              return (
                <div className="sliderItemBox">
                  <ProductCard loading={loading} data={ver} />
                </div>
              );
            })
          )}
        </div>
      </Container>


      {/* Double AD Slider  */}
      {loading ? (
        <Loading height={"350px"} count={4} />
      )
        : (
          <>

            <div className="row my-5">
              <div className="col-6">
                <AdSlider srcData={adSrc} classImg={"doubleSliderbox"} />
              </div>

              <div className="col-6">
                <AdSlider srcData={adSrc} classImg={"doubleSliderbox"} />
              </div>

            </div>
          </>
        )}

      {loading ? (
        <Loading height={"350px"} count={4} />
      ) : (
        data?.category_ads?.map(cat => {
          return (
            <Container
              title={cat.title}
              subtitle={`آگهی های ${cat.title} `}
              link={"مشاهده همه"}
              className="mb-4"
              to={`/ads/all?category_parent_id=${cat.id}`}
            >
              <CustomSlider
                data={cat.ads_parent}
                numbers={4}
                renderCard={catads => {
                  return (
                    <div className="sliderItemBox">
                      <ProductCard loading={loading} data={catads} />
                    </div>
                  );
                }}
              />
            </Container>
          );
        })
      )}
      <Container
        title={"آگهی های اخیر"}
        subtitle="این آگهی ها توسط صنعتبان تایید شده است"
        link={"مشاهده همه"}
        className="mb-4"
        to="/ads/add?sort=newer"
      >
        <div className="row">
          {loading ? (
            <Loading count={9} col={4} />
          ) : (
            data?.last_ads?.map((ver, index) => {
              if (index < 15) {
                return (
                  <div className="col-md-6 col-lg-4 mb-md-3">
                    <RecentProductCard loading={loading} data={ver} />
                  </div>
                );
              }
            })
          )}
        </div>
      </Container>
      <Application styles="mb-5" />
      <PartenersCard />

      {/* Single AD Slider  */}
      {loading ? (
        <Loading height={"350px"} count={4} />
      )
        : (
          <>
            <div className="row my-5">
              <div className="col-12">
                <AdSlider srcData={adSrc2} classImg={"doubleSliderbox"} />
              </div>
            </div>
          </>
        )}


    </div>
  );
};

export default Home;
